<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<option *ngIf="isValueOptionMissing" value="{{model.value}}" disabled selected>{{model.value}}</option>
<option *ngFor="let value of model && model.options; let index = index" value="{{value}}"
  [attr.selected]="model.value === value ? '' : null">
  {{formattedOptions[index]}}
</option>